<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>訊息內容</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="content-info-person">公告人: {{ message.announcer }}</div>
      <div class="content-info-date">發布時間: {{ message.postTime }}</div>
    </div>
    <div class="row content">
      <pre class="contentStyle">{{ message.content }}</pre>
    </div>
    <div class="row col-md-8">
      <span
        v-if="message.requireDriverResponse"
        style="font-size: 2rem; color: red"
      >
        <i class="el-icon-check"></i>
        需要司機回覆
      </span>
      <span v-if="message.isImportant" style="font-size: 2rem; color: red">
        <i class="el-icon-star-on"></i>
        重要訊息
      </span>
      <table
        class="table table-striped jambo_table bulk_action table-font-size"
      >
        <thead>
          <tr class="headings fontSize16">
            <th class="column-title">隊編/呼號</th>
            <th class="column-title">發送時間</th>
            <th class="column-title">點擊時間</th>
            <th v-if="message.requireDriverResponse" class="column-title">
              回覆內容
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="{
              driverCallNumber,
              sendMessageTime,
              replyMessageTime,
              driverResponse,
            } in message.messageDetailData"
          >
            <tr
              class="headings fontSize16"
              :key="driverCallNumber + sendMessageTime"
            >
              <th class="subject-simply">{{ driverCallNumber }}</th>
              <th>{{ sendMessageTime }}</th>
              <th>
                {{ replyMessageTime ? replyMessageTime : null }}
              </th>
              <th v-if="message.requireDriverResponse">
                {{ driverResponse ? driverResponse : null }}
              </th>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import dayjs from 'dayjs'

export default {
  name: 'MessageDetail',
  data() {
    return {
      id: this.$route.params.id,
      message: [],
    }
  },
  mounted() {
    API.get(`message/v2/${this.id}`)
      .then((res) => {
        this.message = res.result
        this.message.postTime = this.message.postTime
          ? dayjs(this.message.postTime).format('YYYY-MM-DD HH:mm:ss')
          : null
        this.message.messageDetailData.forEach((res) => {
          res.sendMessageTime = res.sendMessageTime
            ? dayjs(res.sendMessageTime).format('YYYY-MM-DD HH:mm:ss')
            : null
          res.replyMessageTime = res.replyMessageTime
            ? dayjs(res.replyMessageTime).format('YYYY-MM-DD HH:mm:ss')
            : null
        })
      })
      .catch((e) => {
        console.error(e)
      })
  },
}
</script>
<style scoped>
.content-info-person {
  display: inline-block;
  color: #404040;
  font-size: 18px;
}

.content-info-date {
  display: inline-block;
  margin-left: 100px;
  color: #ff4d4d;
  font-size: 18px;
}

.contentStyle {
  font-size: 16px;
  padding: 10px;
  border: solid 2px #e6f2ff;
  height: 150px;
  overflow: scroll;
}

.content {
  margin-top: 10px;
}

.myButtonStyle {
  float: right;
  font-size: 16px;
  padding: 5px 20px;
}

.table-font-size {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/message/MessageDetail.vue